<template>
  <div
    class="section-lock-badge"
    :class="{ 'section-lock-badge--tab': size === 'tab' }"
    title="Locked Section"
    aria-label="Locked Section"
  >
    <svg class="section-lock-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M17 8h-1V6a4 4 0 0 0-8 0v2H7a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2zm-7-2a2 2 0 0 1 4 0v2h-4V6zm7 13H7v-9h10v9zm-5-2.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
      />
    </svg>
    <span class="section-lock-tooltip">Locked Section</span>
  </div>
</template>

<script>
export default {
  name: 'SectionLockBadge',
  props: {
    size: {
      type: String,
      default: 'default',
      validator: (v) => ['default', 'tab'].includes(v),
    },
  },
};
</script>

<style scoped>
.section-lock-badge {
  position: relative;
  flex: 0 0 46px;
  width: 46px;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #9b9b9b;
  color: #ffffff;
  border-radius: 14px 0 0 14px;
  z-index: 2;
}

.section-lock-badge--tab {
  flex: 0 0 34px;
  width: 34px;
  border-radius: 40px 0 0 40px;
}

.section-lock-icon {
  width: 22px;
  height: 22px;
  display: block;
}

.section-lock-badge--tab .section-lock-icon {
  width: 16px;
  height: 16px;
}

.section-lock-tooltip {
  position: absolute;
  left: 50%;
  top: -26px;
  transform: translateX(-50%);
  white-space: nowrap;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
  background: #9ded6c;
  color: #000;
  padding: 3px 6px;
  border-radius: 6px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.15s ease;
  z-index: 5;
}

.section-lock-tooltip::before {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -5px;
  transform: translateX(-50%);
  width: 10px;
  height: 10px;
  background: #9ded6c;
  clip-path: polygon(0 0, 50% 100%, 100% 0);
}

.section-lock-badge:hover .section-lock-tooltip {
  opacity: 1;
  visibility: visible;
}
</style>
